<ng-container [formGroup]="form">
  <ng-container formGroupName="legal">
    <div class="form-group" [hidden]="legal?.disabled">
      <h3>{{ labels.legalForm.legalForm }}</h3>
      <div class="form-row">
        <div
          *ngIf="legal.get('legalFormDropdown') as legalFormDropdown"
          class="form-group col-lg-2"
          [hidden]="legalFormDropdown.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.legalFormDropdown"
            [labelId]="'legalFormDropdown'"
            [items]="legalFormDropdownItems"
            closeOnSelect="true"
            formControlName="legalFormDropdown"
            [readonly]="legalFormDropdown.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="legal.get('formOfSecurities') as formOfSecurities"
          class="form-group col-lg-2"
          [hidden]="formOfSecurities.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.formOfSecurities"
            [labelId]="'formOfSecurities'"
            [items]="formOfSecuritiesItems"
            closeOnSelect="true"
            formControlName="formOfSecurities"
            [readonly]="formOfSecurities.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="legal.get('issuerEntity') as issuerEntity"
          class="form-group col-lg-4"
          [hidden]="issuerEntity.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.issuerEntity"
            [labelId]="'issuerEntityId'"
            [items]="issuerEntityItems"
            closeOnSelect="true"
            formControlName="issuerEntityId"
            [readonly]="issuerEntity.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="legal.get('legalProgramme') as legalProgramme"
          class="form-group col-lg-4"
          [hidden]="legalProgramme.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.legalProgramme"
            [labelId]="'legalProgramme'"
            [items]="legalProgrammeItems"
            closeOnSelect="true"
            formControlName="legalProgramme"
            [readonly]="legalProgramme.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="legal.get('depositTaker') as depositTaker"
          class="form-group col-lg-2"
          [hidden]="depositTaker.disabled"
        >
          <app-dc-input
            [label]="labels.legalForm.legal.depositTaker"
            [id]="'depositTaker'"
            type="text"
            formControlName="depositTaker"
            [readonly]="depositTaker.readOnly"
          ></app-dc-input>
        </div>
      </div>
      <div class="form-row">
        <div
          *ngIf="legal.get('governingLaws') as governingLaws"
          class="form-group col-lg-2"
          [hidden]="governingLaws.disabled"
        >
          <app-dc-select
            label="Governing Laws"
            [labelId]="'governingLaws'"
            [items]="governingLawsItems"
            closeOnSelect="true"
            formControlName="governingLaws"
            [readonly]="governingLaws.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="
            legal.get('eligibleLiabilityFormat') as eligibleLiabilityFormat
          "
          class="form-group col-lg-2"
          [hidden]="eligibleLiabilityFormat.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.eligibleLiabilityFormat"
            [labelId]="'eligibleLiabilityFormat'"
            [items]="eligibleLiabilityFormatItems"
            closeOnSelect="true"
            formControlName="eligibleLiabilityFormat"
          ></app-dc-select>
        </div>
        <div
          *ngIf="legal.get('listingStatus') as listingStatus"
          class="form-group col-lg-2"
          [hidden]="listingStatus.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.listingStatus"
            [labelId]="'listingStatus'"
            [items]="listingStatusItems"
            closeOnSelect="true"
            formControlName="listingStatus"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="legal.get('listingVenue') as listingVenue"
          class="form-group col-lg-4"
          [hidden]="listingVenue.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.listingVenue"
            [labelId]="'listingVenue'"
            [items]="listingVenueItems"
            closeOnSelect="true"
            formControlName="listingVenue"
            [clearSelection]="true"
            [multiple]="true"
            [checkbox]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="legal.get('wrapper') as wrapper"
          class="form-group col-lg-2"
          [hidden]="wrapper.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.wrapper"
            [labelId]="'wrapper'"
            [items]="wrapperDropdownItems"
            closeOnSelect="true"
            formControlName="wrapper"
            multiple="true"
            checkbox="true"
            [readonly]="wrapper.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
      </div>
      <div class="form-row">
        <div
          *ngIf="legal.get('tradingInUnits') as tradingInUnits"
          class="form-group col-lg-2"
          [hidden]="tradingInUnits.disabled"
        >
          <app-dc-select
            [label]="labels.legalForm.legal.tradingInUnits"
            [labelId]="'tradingInUnits'"
            [items]="YES_NO"
            closeOnSelect="true"
            formControlName="tradingInUnits"
            [readonly]="tradingInUnits.readOnly"
            (selected)="onTradingInUnitsChange($event)"
          ></app-dc-select>
        </div>
        <ng-container *ngIf="!isTradingInUnits; else tradingInUnitsTemp">
          <div
            *ngIf="legal.get('notional') as notional"
            class="form-group col-lg-2"
            [hidden]="notional.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.notional"
              [id]="'notional'"
              formControlName="notional"
              [readonly]="notional.readOnly"
              (change)="onNotionalChange($event)"
            ></app-dc-input-numeric>
          </div>
          <ng-container
            *ngTemplateOutlet="denominationAndIssuePrice"
          ></ng-container>
        </ng-container>
        <ng-template #tradingInUnitsTemp>
          <div
            *ngIf="legal.get('numberOfUnits') as numberOfUnits"
            class="form-group col-lg-2"
            [hidden]="numberOfUnits.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.numberOfUnits"
              [id]="'numberOfUnits'"
              formControlName="numberOfUnits"
              [readonly]="numberOfUnits.readOnly"
              (onChange)="onNumberOfUnitsChange($event)"
            ></app-dc-input-numeric>
          </div>
          <ng-container
            *ngTemplateOutlet="denominationAndIssuePrice"
          ></ng-container>
        </ng-template>

        <ng-template #denominationAndIssuePrice>
          <div
            *ngIf="legal.get('denominationLegal') as denominationLegal"
            class="form-group col-lg-2"
            [hidden]="denominationLegal.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.denominationLegal"
              [id]="'denominationLegal'"
              formControlName="denominationLegal"
              [readonly]="denominationLegal.readOnly"
              (onChange)="onDenominationChange($event)"
            ></app-dc-input-numeric>
          </div>
          <div
            *ngIf="legal.get('issuePriceLegal') as issuePriceLegal"
            class="form-group col-lg-2"
            [hidden]="issuePriceLegal.disabled"
          >
            <app-dc-input-number-percent-indicative-final
              [label]="labels.legalForm.legal.issuePriceLegal"
              [id]="'issuePriceLegal'"
              formControlName="issuePriceLegal"
              [readonly]="issuePriceLegal.readOnly"
              defaultUnit="pct"
            ></app-dc-input-number-percent-indicative-final>
          </div>
        </ng-template>
      </div>
      <ng-container *ngIf="!isTradingInUnits">
        <div class="form-row">
          <div
            *ngIf="legal.get('maxIssueSizeNotional') as maxIssueSizeNotional"
            class="form-group col-lg-2"
            [hidden]="maxIssueSizeNotional.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.maxIssueSizeNotional"
              [id]="'maxIssueSizeNotional'"
              formControlName="maxIssueSizeNotional"
              [readonly]="maxIssueSizeNotional.readOnly"
              (onChange)="onMaxIssueNotionalChange($event)"
            ></app-dc-input-numeric>
          </div>
          <div
            *ngIf="legal.get('minTradingAmountLegal') as minTradingAmountLegal"
            class="form-group col-lg-2"
            [hidden]="minTradingAmountLegal.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.minTradingAmountLegal"
              [id]="'minTradingAmountLegal'"
              formControlName="minTradingAmountLegal"
              [readonly]="minTradingAmountLegal.readOnly"
              (onChange)="onMinTradingAmountChange($event)"
            ></app-dc-input-numeric>
          </div>
          <div
            *ngIf="
              legal.get('incrementalTradingAmount') as incrementalTradingAmount
            "
            class="form-group col-lg-2"
            [hidden]="incrementalTradingAmount.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.incrementalTradingAmount"
              [id]="'incrementalTradingAmount'"
              formControlName="incrementalTradingAmount"
              [readonly]="incrementalTradingAmount.readOnly"
              [customErrorMessage]="
                incrementalTradingAmount.errors
                  | incrementalErrorMessage: 'amount'
              "
              (onChange)="
                onIncrementalTradingChange('incrementalTradingAmount')
              "
            ></app-dc-input-numeric>
          </div>
          <div
            *ngIf="legal.get('maxTradingAmountLegal') as maxTradingAmountLegal"
            class="form-group col-lg-2"
            [hidden]="maxTradingAmountLegal.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.maxTradingAmountLegal"
              [id]="'maxTradingAmountLegal'"
              formControlName="maxTradingAmountLegal"
              [readonly]="maxTradingAmountLegal.readOnly"
              (onChange)="onMaxTradingAmountChange($event)"
            ></app-dc-input-numeric>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isTradingInUnits">
        <div class="form-row">
          <div
            *ngIf="legal.get('maxIssueSizeUnits') as maxIssueSizeUnits"
            class="form-group col-lg-2"
            [hidden]="maxIssueSizeUnits.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.maxIssueSizeUnits"
              [id]="'maxIssueSizeUnits'"
              formControlName="maxIssueSizeUnits"
              [readonly]="maxIssueSizeUnits.readOnly"
              (onChange)="onMaxIssueUnitsChange($event)"
            ></app-dc-input-numeric>
          </div>
          <div
            *ngIf="legal.get('minTradingUnits') as minTradingUnits"
            class="form-group col-lg-2"
            [hidden]="minTradingUnits.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.minTradingUnits"
              [id]="'minTradingUnits'"
              formControlName="minTradingUnits"
              [readonly]="minTradingUnits.readOnly"
              (onChange)="onMinTradingUnitsChange($event)"
            ></app-dc-input-numeric>
          </div>
          <div
            *ngIf="
              legal.get('incrementalTradingUnits') as incrementalTradingUnits
            "
            class="form-group col-lg-2"
            [hidden]="incrementalTradingUnits.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.incrementalTradingUnits"
              [id]="'incrementalTradingUnits'"
              formControlName="incrementalTradingUnits"
              [readonly]="incrementalTradingUnits.readOnly"
              [customErrorMessage]="
                incrementalTradingUnits.errors
                  | incrementalErrorMessage: 'units'
              "
              (onChange)="onIncrementalTradingChange('incrementalTradingUnits')"
            ></app-dc-input-numeric>
          </div>
          <div
            *ngIf="legal.get('maxTradingUnits') as maxTradingUnits"
            class="form-group col-lg-2"
            [hidden]="maxTradingUnits.disabled"
          >
            <app-dc-input-numeric
              [label]="labels.legalForm.legal.maxTradingUnits"
              [id]="'maxTradingUnits'"
              formControlName="maxTradingUnits"
              [readonly]="maxTradingUnits.readOnly"
              (onChange)="onMaxTradingUnitsChange($event)"
            ></app-dc-input-numeric>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container formGroupName="countriesOfOffer">
    <div class="form-group" [hidden]="form.get('countriesOfOffer')?.disabled">
      <h3>{{ labels.legalForm.countriesOfOffer.countriesOfOffer }}</h3>
      <div
        formArrayName="countriesOfOfferArr"
        [hidden]="
          form.get('countriesOfOffer')?.get('countriesOfOfferArr')?.disabled
        "
      >
        <div
          *ngFor="
            let country of countriesOfOfferRow.controls;
            let i = index;
            let last = last;
            let first = first
          "
        >
          <ng-container
            *ngIf="
              form
                .get('countriesOfOffer')
                .get('countriesOfOfferArr')
                .at(i) as group
            "
          >
            <div>
              <div class="form-row align-items-end" [formGroupName]="i">
                <div class="form-row col-lg-11">
                  <div class="form-group col-lg-6">
                    <app-dc-select
                      [label]="
                        labels.legalForm.countriesOfOffer.jurisdictionsLegal
                          | multilineLabel: i
                      "
                      [labelId]="'jurisdictionsLegal'"
                      [items]="jurisdictionsItems"
                      closeOnSelect="true"
                      formControlName="jurisdictionsLegal"
                      [searchable]="true"
                      [clearSelection]="true"
                      (selected)="onJurisdictionsLegalChange(i)"
                    ></app-dc-select>
                  </div>
                  <div class="form-group col-lg-4">
                    <app-dc-select
                      [label]="
                        labels.legalForm.countriesOfOffer.formOfOfferLegal
                          | multilineLabel: i
                      "
                      [labelId]="'formOfOfferLegal'"
                      [items]="formOfOfferItems"
                      closeOnSelect="true"
                      formControlName="formOfOfferLegal"
                      [clearSelection]="true"
                      [readonly]="!group.get('jurisdictionsLegal').value"
                    ></app-dc-select>
                  </div>
                  <div class="form-group col-lg-2">
                    <app-dc-select
                      [label]="
                        labels.legalForm.countriesOfOffer.subscription
                          | multilineLabel: i
                      "
                      [labelId]="'subscription'"
                      [items]="YES_NO"
                      closeOnSelect="true"
                      formControlName="subscription"
                      (selected)="onSubscriptionChange(i)"
                      [readonly]="!group.get('jurisdictionsLegal').value"
                    ></app-dc-select>
                  </div>
                </div>
                <app-dc-plus-minus
                  (minusClick)="deleteCountriesOfOfferRow(i)"
                  (plusClick)="addCountriesOfOfferRow()"
                  [showPlus]="last"
                  *ngIf="!group.get('jurisdictionsLegal').readOnly"
                >
                </app-dc-plus-minus>
              </div>
              <div class="form-row align-items-end" [formGroupName]="i">
                <div
                  formArrayName="subscriptions"
                  [hidden]="group.get('subscription')?.disabled"
                  class="px-5"
                >
                  <h6
                    style="text-transform: uppercase"
                    *ngIf="group.get('subscriptions').controls.length"
                  >
                    {{ labels.legalForm.countriesOfOffer.subscriptions }}
                  </h6>
                  <div
                    *ngFor="
                      let subscription of group.get('subscriptions').controls;
                      let j = index;
                      let last = last;
                      let first = first
                    "
                    [formGroupName]="j"
                    class="ml-5"
                  >
                    <div class="form-row">
                      <div class="form-group col-lg-2" style="width: 180px">
                        <app-dc-date-input
                          [label]="
                            labels.legalForm.countriesOfOffer.subStartDate
                              | multilineLabel: j
                          "
                          [id]="'subStartDate' + i + '_' + j"
                          placeholder=""
                          formControlName="subStartDate"
                          [showTime]="true"
                          container="body"
                        ></app-dc-date-input>
                      </div>
                      <div class="form-group col-lg-2" style="width: 180px">
                        <app-dc-date-input
                          [label]="
                            labels.legalForm.countriesOfOffer.subEndDate
                              | multilineLabel: j
                          "
                          [id]="'subEndDate' + i + '_' + j"
                          placeholder=""
                          formControlName="subEndDate"
                          [showTime]="true"
                          container="body"
                        ></app-dc-date-input>
                      </div>
                      <div
                        class="form-group col-lg-2"
                        style="width: 180px"
                        *ngIf="
                          group.get('jurisdictionsLegal').value ===
                            'United Kingdom' ||
                          group.get('jurisdictionsLegal').value === 'UK'
                        "
                      >
                        <app-dc-date-input
                          [label]="
                            labels.legalForm.countriesOfOffer.isaEndDate
                              | multilineLabel: j
                          "
                          [id]="'isaEndDate' + i + '_' + j"
                          placeholder=""
                          formControlName="isaEndDate"
                          container="body"
                          [showTime]="true"
                        ></app-dc-date-input>
                      </div>
                      <div class="form-group col-lg-2" style="width: 180px">
                        <app-dc-select
                          [label]="
                            labels.legalForm.countriesOfOffer.timezone
                              | multilineLabel: j
                          "
                          [id]="'timezone' + i + '_' + j"
                          [items]="subscription.get('timezones').value"
                          placeholder=""
                          formControlName="timezone"
                          [closeOnSelect]="true"
                        ></app-dc-select>
                      </div>
                      <div class="form-group col-lg-2" style="width: 180px">
                        <app-dc-input
                          [label]="
                            labels.legalForm.countriesOfOffer
                              .distributionChannel | multilineLabel: j
                          "
                          [id]="'distributionChannel' + i + '_' + j"
                          placeholder=""
                          formControlName="distributionChannel"
                        ></app-dc-input>
                      </div>
                      <app-dc-plus-minus
                        (minusClick)="deleteSubscriptionRow(i, j)"
                        (plusClick)="addSubscriptionRow(i)"
                        [showPlus]="last"
                        *ngIf="group.get('subscriptions').controls.length"
                      >
                      </app-dc-plus-minus>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container formGroupName="productIdentifiers">
    <div class="form-group" [hidden]="form.get('productIdentifiers')?.disabled">
      <h3>{{ labels.legalForm.productIdentifiers.productIdentifiers }}</h3>
      <div
        formArrayName="productIdentifiersArr"
        [hidden]="
          form.get('productIdentifiers')?.get('productIdentifiersArr')?.disabled
        "
      >
        <div
          *ngFor="
            let product of getProductRow.controls;
            let i = index;
            let last = last;
            let first = first
          "
        >
          <div class="form-row align-items-end" [formGroupName]="i">
            <ng-container
              *ngIf="
                form
                  .get('productIdentifiers')
                  .get('productIdentifiersArr')
                  .at(i) as group
              "
            >
              <ng-container *ngIf="i === 0">
                <div class="form-group col-lg-2">
                  <app-dc-select
                    [label]="
                      labels.legalForm.productIdentifiers.typeProdIdentifiers
                    "
                    [labelId]="'typeProdIdentifiers'"
                    [items]="productIdentifiersTypes"
                    closeOnSelect="true"
                    formControlName="typeProdIdentifiers"
                    [searchable]="true"
                    [FreeText]="true"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
                <div class="form-group col-lg-4">
                  <app-dc-input
                    [label]="
                      labels.legalForm.productIdentifiers.codeProdIdentifiers
                    "
                    [id]="'codeProdIdentifiers'"
                    type="text"
                    formControlName="codeProdIdentifiers"
                    [customErrorMessage]="
                      group.valueChanges | async | customErrorsText: group
                    "
                  >
                  </app-dc-input>
                </div>
                <app-dc-plus-minus
                  *ngIf="!group.get('typeProdIdentifiers').readOnly"
                  (plusClick)="addRow()"
                  (minusClick)="deleteRow(i)"
                  [showPlus]="first === last"
                >
                </app-dc-plus-minus>
              </ng-container>
              <ng-container *ngIf="i > 0">
                <div class="form-group col-lg-2">
                  <app-dc-select
                    [items]="productIdentifiersTypes"
                    closeOnSelect="true"
                    formControlName="typeProdIdentifiers"
                    [searchable]="true"
                    [FreeText]="true"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
                <div class="form-group col-lg-4">
                  <app-dc-input
                    [id]="'codeProdIdentifiers'"
                    type="text"
                    formControlName="codeProdIdentifiers"
                    [customErrorMessage]="
                      group.valueChanges | async | customErrorsText: group
                    "
                  >
                  </app-dc-input>
                </div>
                <app-dc-plus-minus
                  *ngIf="!group.get('typeProdIdentifiers').readOnly"
                  (plusClick)="addRow()"
                  [showPlus]="last"
                  (minusClick)="deleteRow(i)"
                >
                </app-dc-plus-minus>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-group" [formGroup]="form">
    <h3>Others</h3>
    <div class="form-group col-2" formGroupName="legal">
      <app-dc-select
        [label]="labels.legalForm.legal.securedIssuance"
        [items]="YES_NO"
        closeOnSelect="true"
        formControlName="securedIssuance"
      ></app-dc-select>
    </div>
  </div>
</ng-container>
